<template>
  <span>
    <v-main class="px-0">
      <div class="title mb-3">
        Sections
      </div>

      <v-skeleton-loader
        v-if="loading"
        ref="skeleton"
        :boilerplate="false"
        :type="'list-item-three-line'"
        class="mx-auto"
        width="100vw"
        max-width="600"
      />

      <v-expansion-panels
        v-else-if="!loading && sections && sections.length > 0"
        :key="`Resource${resource.id}`"
        class="mb-8"
        hover
        focusable
        multiple
      >
        <v-expansion-panel
          v-for="(section, key) in sections"
          :key="key"
        >
          <v-expansion-panel-header>
            {{ section.name }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <Video
              :key="`VideoSection${section.id}`"
              :section="section"
              :show-error.sync="showErrorModal"
            />

            <Downloadable
              :key="`DownloadSection${section.id}`"
              :section="section"
              :show-error.sync="showErrorModal"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div v-else>
        No data to display
      </div>
    </v-main>

    <ErrorModal
      :show.sync="showErrorModal"
    />
  </span>
</template>

<script>
import resourceApi from '@/api/coach-profile/resource';
import Video from './Video.vue';
import Downloadable from './Downloadable.vue';
import ErrorModal from './ErrorModal.vue';

export default {
  name: 'Section',

  components: {
    Video,
    Downloadable,
    ErrorModal,
  },

  props: {
    resource: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    loading: false,
    sections: null,
    showErrorModal: false,
  }),

  watch: {
    resource: {
      deep: true,
      handler(a, b) {
        if (a.id !== b.id) {
          this.getSection();
        }
      },
    },
  },

  mounted() {
    this.getSection();
  },

  methods: {
    async getSection() {
      try {
        this.loading = true;
        this.sections = await resourceApi.getSection(this.resource.id);
      } catch (err) {
        console.log('Section get', err);
        this.$toast.error(err.msg || err.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
